module.exports = __webpack_public_path__ + "img/wb.5aef59fc.png";